import { localStorageAdapter } from '../LocalStorageAdapter';
var handleGetData = function handleGetData(event, postMessageService) {
  var _event$data = event.data,
    key = _event$data.key,
    message_id = _event$data.message_id;
  if (!key) {
    postMessageService.sendBadRequestErrorPostMessageResponse('Missing required "key" field');
    return true;
  }
  if (!message_id) {
    postMessageService.sendBadRequestErrorPostMessageResponse('Missing required "message_id" field"');
    return true;
  }
  var value = localStorageAdapter.getData(event.origin, key);
  postMessageService.sendSuccessPostMessageResponse('lti.get_data', {
    key: key,
    value: value
  }, event.source, event.origin);
};
export default handleGetData;